import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(fetchAllSpendHandler),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(updateSpendSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(updateRepeatMonthlySaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(fetchAllSpendListener);

import { put, select, takeLatest } from 'redux-saga/effects';
import createRequestSaga from '@signal/utils/createRequestSaga';
import applyUrlParams from '@signal/utils/applyUrlParams';
import api from '../api';
import { activeAccountIdSelector } from '../auth/selectors';
import { fetchAllSpendActions, changeDate, updateSpend, updateRepeatMonthly, updateChannelActions } from './actions';
import { API_ENDPOINT } from './constants';
import { isLoadingSelector, isLoadedSelector, dateContextSelector, channelSelector } from './selectors';
export function fetchAllSpendHandler() {
  var dateContext, accountId;
  return _regeneratorRuntime.wrap(function fetchAllSpendHandler$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(dateContextSelector);

        case 2:
          dateContext = _context.sent;
          _context.next = 5;
          return select(activeAccountIdSelector);

        case 5:
          accountId = _context.sent;
          _context.next = 8;
          return put(api.get(fetchAllSpendActions, applyUrlParams("".concat(API_ENDPOINT, "/").concat(accountId), {
            date: dateContext
          })));

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export var loadAllSpend = createRequestSaga(fetchAllSpendActions, {
  loadingSelector: isLoadingSelector,
  loadedSelector: isLoadedSelector
});
export function updateChannel(accountId, channel) {
  var key = channel.key,
      spend = channel.spend,
      repeat = channel.repeat;
  return api.post(updateChannelActions, "".concat(API_ENDPOINT, "/").concat(accountId), {
    body: [{
      spendkey: key,
      amount: spend,
      repeat: repeat
    }]
  }, {
    request: function request() {
      return key;
    },
    success: function success() {
      return key;
    },
    failure: function failure(error) {
      return {
        error: error,
        key: key
      };
    }
  });
} // TODO cache control no cache

export function updateSpendSaga(_ref) {
  var payload, key, value, amount, channel, accountId;
  return _regeneratorRuntime.wrap(function updateSpendSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          key = payload.key, value = payload.value;
          amount = value === '' ? 0 : value;
          _context2.next = 5;
          return select(channelSelector, {
            key: key
          });

        case 5:
          channel = _context2.sent;
          _context2.next = 8;
          return select(activeAccountIdSelector);

        case 8:
          accountId = _context2.sent;
          _context2.next = 11;
          return put(updateChannel(accountId, {
            key: key,
            // update spend
            spend: amount,
            // maintain repeat
            repeat: channel.repeat
          }));

        case 11:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function updateRepeatMonthlySaga(_ref2) {
  var payload, key, repeat, channel, accountId;
  return _regeneratorRuntime.wrap(function updateRepeatMonthlySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _ref2.payload;
          key = payload.key, repeat = payload.repeat;
          _context3.next = 4;
          return select(channelSelector, {
            key: key
          });

        case 4:
          channel = _context3.sent;
          _context3.next = 7;
          return select(activeAccountIdSelector);

        case 7:
          accountId = _context3.sent;
          _context3.next = 10;
          return put(updateChannel(accountId, {
            key: key,
            // maintain current spend
            spend: channel.spend,
            // update repeat
            repeat: repeat
          }));

        case 10:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function fetchAllSpendListener() {
  return _regeneratorRuntime.wrap(function fetchAllSpendListener$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest([fetchAllSpendActions.load, changeDate.getType()], fetchAllSpendHandler);

        case 2:
          _context4.next = 4;
          return takeLatest(updateSpend.getType(), updateSpendSaga);

        case 4:
          _context4.next = 6;
          return takeLatest(updateRepeatMonthly.getType(), updateRepeatMonthlySaga);

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}